import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { motion, useMotionValue, useSpring } from "framer-motion";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Ministry from "@/components/Ministry";
import Warfare from "@/components/Warfare";
import Associates from "@/components/Associates";
import Wellness from "@/components/Wellness";
import Books from "@/components/Books";
import Coaching from "@/components/Coaching";
import Invite from "@/components/Invite";
import Give from "@/components/Give";
import Contact from "@/components/Contact";
import SubmissionsDrawer from "@/components/SubmissionsDrawer";

const CursorGlow = () => {
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 50, damping: 20 });
  const sy = useSpring(y, { stiffness: 50, damping: 20 });
  useEffect(() => {
    const move = (e) => { x.set(e.clientX - 300); y.set(e.clientY - 300); };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);
  return (
    <motion.div aria-hidden className="pointer-events-none fixed left-0 top-0 z-40 h-[600px] w-[600px] rounded-full mix-blend-screen"
      style={{ x: sx, y: sy, background: "radial-gradient(circle, rgba(139,92,246,0.14) 0%, rgba(245,158,11,0.07) 40%, transparent 65%)" }} />
  );
};

const AuroraBackground = () => (
  <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
    <div className="aurora-blob absolute -top-40 -left-40 h-[36rem] w-[36rem] rounded-full bg-violet-600/15 blur-[130px]" />
    <div className="aurora-blob-reverse absolute top-1/3 -right-52 h-[32rem] w-[32rem] rounded-full bg-amber-500/10 blur-[130px]" />
    <div className="aurora-blob absolute bottom-0 left-1/4 h-[26rem] w-[26rem] rounded-full bg-cyan-500/10 blur-[130px]" style={{ animationDelay: "-6s" }} />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#06070B] text-slate-200 font-sans overflow-x-hidden">
      <AuroraBackground />
      <CursorGlow />
      <div className="noise-overlay" />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <About />
        <Ministry />
        <Warfare />
        <Associates />
        <Wellness />
        <Books />
        <Coaching />
        <Invite />
        <Give />
        <Contact />
      </main>
      <SubmissionsDrawer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
